import { render, staticRenderFns } from "./IconChefMale.vue?vue&type=template&id=4a906d4e&"
import script from "./IconChefMale.vue?vue&type=script&lang=js&"
export * from "./IconChefMale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports